// The ONE definition of "the answer REPEATS the last call's note"
// (DESIGN-WL-ASSISTANT-MAIN-VIEW-1, approved (A) 2026-09-29) — used by BOTH
// halves of the thread, like toolEmbed.js / toolOutcome.js:
//   live turn    — simoneAiTransport onDone: the server's final text vs the
//                  note the last call took at its `started` frame
//   history load — sessions._toChatMessages: an answer row's text vs the note
//                  its last call restored from the saved callText (core-wl
//                  part 3: [text before] + tool_call + [text after])
// A model can say a sentence beside its call and then say it AGAIN as its
// final answer (dev, Unreal twin, 2026-09-29: "Here are the 5 biggest open
// deals by value." showed as the call's note AND as the answer). Equal after
// whitespace normalization → the thread shows it ONCE, as the answer, and the
// call's note clears. Any other difference keeps both: only an exact repeat
// folds, so a note that says something the answer does not is never lost.
const words = (s) => (typeof s === 'string' ? s.replace(/\s+/g, ' ').trim() : '')

export const repeatsNote = (answer, note) => {
  const said = words(answer)
  return !!said && said === words(note)
}
